import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In your `}<inlineCode parentName="p">{`src/components`}</inlineCode>{` folder, create a `}<inlineCode parentName="p">{`posthog.astro`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd ./src/components 
# or 'cd ./src && mkdir components && cd ./components' if your components folder doesnt exist 
touch posthog.astro
`}</code></pre>
    <p>{`In this file, add your `}<inlineCode parentName="p">{`Web snippet`}</inlineCode>{` which you can find in `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project#snippet"
      }}>{`your project settings`}</a>{`. Be sure to include the `}<inlineCode parentName="p">{`is:inline`}</inlineCode>{` directive `}<a parentName="p" {...{
        "href": "https://docs.astro.build/en/guides/client-side-scripts/#opting-out-of-processing"
      }}>{`to prevent Astro from processing it`}</a>{`, or you will get Typescript and build errors that property 'posthog' does not exist on type 'Window & typeof globalThis'.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-astro",
        "metastring": "file=posthog.astro",
        "file": "posthog.astro"
      }}>{`---
// src/components/posthog.astro
---
<script is:inline>
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys getNextSurveyStep onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  posthog.init('<ph_project_api_key>', {
    api_host:'<ph_client_api_host>',
    defaults: '<ph_posthog_js_defaults>'
  })
</script>
`}</code></pre>
    <p>{`The next step is to a create a `}<a parentName="p" {...{
        "href": "https://docs.astro.build/en/core-concepts/layouts/"
      }}>{`Layout`}</a>{` where we will use `}<inlineCode parentName="p">{`posthog.astro`}</inlineCode>{`. Create a new file `}<inlineCode parentName="p">{`PostHogLayout.astro`}</inlineCode>{` in your `}<inlineCode parentName="p">{`src/layouts`}</inlineCode>{` folder:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd .. && cd .. # move back to your base directory if you're still in src/components/posthog.astro
cd ./src/layouts
# or 'cd ./src && mkdir layouts && cd ./layouts' if your layouts folder doesn't exist yet
touch PostHogLayout.astro
`}</code></pre>
    <p>{`Add the following code to `}<inlineCode parentName="p">{`PostHogLayout.astro`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-astro",
        "metastring": "file=PostHogLayout.astro",
        "file": "PostHogLayout.astro"
      }}>{`---
import PostHog from '../components/posthog.astro'
---
<head>
    <PostHog />
</head>
`}</code></pre>
    <p>{`Lastly, update `}<inlineCode parentName="p">{`index.astro`}</inlineCode>{` to wrap your existing app components with the new Layout:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-astro",
        "metastring": "file=index.astro",
        "file": "index.astro"
      }}>{`---
import PostHogLayout from '../layouts/PostHogLayout.astro';
---
<PostHogLayout>
  <!-- your existing app components -->
</PostHogLayout>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      